import { jsx as a } from "react/jsx-runtime";
import { c as m } from "./clsx-OuTLNxxd.js";
import { forwardRef as x } from "react";
import { IconList as d } from "./components/elements/icon/iconsList.js";
const p = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, f = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function u(r = 0) {
  const i = [];
  for (let s = 0; s < r; s++)
    i[s] = `path${s + 1}`;
  return i.map((s) => /* @__PURE__ */ a("span", { className: s }, s));
}
const y = x(
  ({ name: r, size: i = "medium", color: s = "base", className: l = "", ...n }, o) => {
    const e = d.find((c) => c.name === r), t = m("icon", `ds-${e?.class}`, f[i], p[s], l);
    return /* @__PURE__ */ a("i", { className: t, ...n, ref: o, children: u(e?.paths) });
  }
);
y.displayName = "Icon";
export {
  y as I,
  p as a,
  f as b
};
